import { useDroppable } from "@dnd-kit/react";
import styled from "styled-components";
import { ProjectsEmptyListRow } from "components/features/projects/ProjectsListRow";



export const ProjectsListWrapper = ({id, title, counter, color, children}) => {

    const hasValidChildren = Array.isArray(children) && children.some(child => child !== null);
    
    const { ref, isDropTarget } = useDroppable({id});

    return (
        <StyledProjectsListWrapper ref={ref} $color = {color} className={isDropTarget ? "isDropTarget" : null}>
            <div className="listWrapperHeader">
                <span className="headerTitle">
                    {title}
                </span>
                <span className="headerCounter">
                    {counter}
                </span>
            </div>
            <div className="listWrapperContent">
                
                {
                    hasValidChildren ? 

                    <div className="listWrapperContentHeading">
                        <div className="headingLeftFiller"/>
                        <div className="headingProjectName">Prosjekt</div>
                        <div className="headingProjectPhase">Prosjektfase</div>
                        <div className="headingProjectContent">Innhold</div>
                        <div className="headingProjectUpdate">Oppdatering</div>
                    </div>
                    : null
                }
                
                <div className="listWrapperContentRows">
                    {hasValidChildren ? children : <ProjectsEmptyListRow/>}
                </div>
                
            </div>
        </StyledProjectsListWrapper>
    )
}

const StyledProjectsListWrapper = styled.div`

    padding-top: ${({theme}) => theme.spacing.md};
    padding-bottom: ${({theme}) => theme.spacing.md};
    transition-duration: 110ms;
    border-radius: ${({theme}) => theme.cornerRadius.md};

    &.isDropTarget
    {
        background: ${({theme}) => theme.colors.mutedBackground};
    }

    div.listWrapperHeader
    {
        display: flex;
        align-items: center;
        gap: ${({theme}) => theme.spacing.md};

        margin-left: ${({theme}) => theme.spacing.md};
        margin-right: ${({theme}) => theme.spacing.md};
        margin-bottom: ${({theme}) => theme.spacing.md};

        span.headerTitle
        {
            position: relative;
            padding-left: calc(${({theme}) => theme.spacing.md} + ${({theme}) => theme.spacing.sm} + 8px);
            font-weight: 500;
            &::before
            {
                top: 50%;
                left: ${({theme}) => theme.spacing.sm};
                transform: translateY(-50%);
                position: absolute;
                content: "";
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: ${({theme, $color}) => $color ? $color : theme.colors.neutralSecondaryForeground};
            }
        }

        span.headerCounter
        {
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top: ${({theme}) => theme.spacing.xs};
            padding-bottom: ${({theme}) => theme.spacing.xs};
            padding-left: ${({theme}) => theme.spacing.md};
            padding-right: ${({theme}) => theme.spacing.md};
            border-radius: ${({theme}) => theme.cornerRadius.md};
            color: ${({theme}) => theme.colors.mutedForeground};
            background: ${({theme}) => theme.colors.mutedBackground};
            font-size: ${({theme}) => theme.fontSize.sm};
            border: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
        }

    }

    div.listWrapperContent
    {
        padding-left: ${({theme}) => theme.spacing.md};
        padding-right: ${({theme}) => theme.spacing.md};

        div.listWrapperContentHeading
        {
            border: 1px solid red;
            display: flex;
            border: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
            background: ${({theme}) => theme.colors.mutedBackground};
            color: ${({theme}) => theme.colors.mutedForeground};
            padding-top: ${({theme}) => theme.spacing.sm};
            padding-bottom: ${({theme}) => theme.spacing.sm};
            border-top-left-radius: ${({theme}) => theme.cornerRadius.md};
            border-top-right-radius: ${({theme}) => theme.cornerRadius.md};
            gap: ${({theme}) => theme.spacing.md};
            padding-left: ${({theme}) => theme.spacing.md};
            padding-right: ${({theme}) => theme.spacing.md};
            font-size: ${({theme}) => theme.fontSize.sm};
            font-weight: 600;
            
            div.headingLeftFiller
            {
                width: 125px;
            }

            div.listProjectNumber
            {
                width: 100px;
                flex: 0 0 100px;
            }

            div.headingProjectName, div.headingProjectUpdate
            {
                flex: 1 0 0;
                
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            div.headingProjectPhase, div.headingProjectContent
            {
                flex: 0.5 0 0;
                
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        
    }
`

